import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="input-filler"
export default class extends Controller {
  static targets = ['sourceInput', 'targetInput', 'submitBtn']

  saveValue() {
    if (this.sourceInputTarget && this.targetInputTarget) {
      this.targetInputTarget.value = this.sourceInputTarget.innerText
    }
  }

  activateSubmitBtn() {
    if (!this.hasSubmitBtnTarget) {
      return
    }

    const hasLoader = document.querySelector('[id^="last_message_chat_"]') !== null
    const hasText = this.sourceInputTarget.innerText.trim() !== ""

    this.submitBtnTarget.disabled = hasLoader || !hasText
  }

  handleKeyPress(event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      const text = this.sourceInputTarget.textContent.trim()

      if (text && !this.submitBtnTarget.disabled) {
        this.targetInputTarget.value = text
        const form = this.submitBtnTarget.form
        form.requestSubmit()
        form.reset()
        this.sourceInputTarget.textContent = ''
      }
    }
  }
}
